import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import logo from '../../../assets/logo.svg';

const Header = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = async () => {
    await logout();
    setShowUserMenu(false);
    navigate('/');
  };

  return (
    <header className="bg-gray-900 text-white py-6">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          {/* Logo and Title */}
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img src={logo} alt="VidCreatorStudio Logo" className="w-10 h-10" />
            <h1 className="text-2xl md:text-4xl font-bold">VidCreator Studio</h1>
          </Link>

          {/* User Menu or Login/Register */}
          <div className="flex items-center gap-4">
            {isAuthenticated && user ? (
              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="flex items-center gap-2 px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg transition-colors"
                >
                  <span className="text-sm font-medium">{user.email}</span>
                  {user.tier === 'premium' && (
                    <span className="px-2 py-0.5 bg-gradient-to-r from-yellow-500 to-orange-500 text-xs font-semibold rounded">Premium</span>
                  )}
                  {user.tier === 'free' && (
                    <span className="px-2 py-0.5 bg-green-600 text-xs font-semibold rounded">Free</span>
                  )}
                  <span className="text-xs">▼</span>
                </button>

                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-64 bg-slate-700 border border-slate-600 rounded-lg shadow-xl z-50">
                    <div className="p-4 border-b border-slate-600">
                      <p className="text-sm text-gray-300 mb-1">{user.email}</p>
                      <p className="text-xs font-semibold">
                        {user.tier === 'premium' && <span className="text-yellow-400">Premium Tier</span>}
                        {user.tier === 'free' && <span className="text-green-400">Free Tier</span>}
                      </p>
                    </div>
                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-3 hover:bg-slate-600 transition-colors text-sm"
                    >
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex items-center gap-3">
                <Link
                  to="/login"
                  className="px-4 py-2 text-sm font-medium text-white hover:text-blue-400 transition-colors"
                >
                  Sign In
                </Link>
                <Link
                  to="/register"
                  className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white text-sm font-semibold rounded-lg transition-colors"
                >
                  Get Started
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
